import React, { useEffect, useState } from 'react';
import styles from '../styles/ContactUs.module.css';
import { getData } from '../ServerRequest.js';
import { color } from 'chart.js/helpers';
import { indigo } from '@mui/material/colors';
import { BiFontFamily, BiItalic } from 'react-icons/bi';

const ContactMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusMap, setStatusMap] = useState({}); // Track status per message

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const token = localStorage.getItem('token');
        const config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        };

        const response = await getData('/api/company/contacts/', config);
        console.log('Fetched contact messages:', response);

        let msgs = [];
        if (response && Array.isArray(response.data)) {
          msgs = response.data;
        } else if (response && response.data && Array.isArray(response.data.data)) {
          msgs = response.data.data;
        } else if (response && Array.isArray(response)) {
          msgs = response;
        }
        setMessages(msgs);
        // Initialize statusMap for each message
        const initialStatus = {};
        msgs.forEach(m => {
          initialStatus[m.id] = 'new';
        });
        setStatusMap(initialStatus);
      } catch (err) {
        console.error('Error fetching contact messages:', err);
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  const handleStatusChange = (id, value) => {
    setStatusMap(prev => ({ ...prev, [id]: value }));
  };

  return (
    <div style={{ padding: '2rem', marginBottom: '1rem' }}>
      <h2 style={{ marginTop: 0, marginBottom: '2.5rem', position: 'relative', padding: '0' }}>Inquiry - User Messages</h2>
      {loading ? (
        <div className={styles.spinnerWrapper}>
          <div className={styles.spinner}></div>
          <div className={styles.spinnerText}>Loading Messages...</div>
        </div>
      ) : (
        <div style={{ marginTop: '0' }}>
          {messages.length === 0 ? (
            <p>No messages found.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1.5rem', }}>
              <thead>
                <tr>
                  <th style={thStyle}>Name</th>
                  <th style={thStyle}>Email</th>
                  <th style={thStyle}>Subject</th>
                  <th style={thStyle}>Message</th>
                  <th style={thStyle}>Phone</th>
                  <th style={thStyle}>Status</th>
                </tr>
              </thead>
              <tbody>
                {messages.map((msg, index) => (
                  <tr key={msg.id || index}>
                    <td style={tdStyle}>{msg.name}</td>
                    <td style={tdStyle}>{msg.email}</td>
                    <td style={tdStyle}>{msg.subject}</td>
                    <td style={tdStyle}>{msg.message}</td>
                    <td style={tdStyle}>{msg.phone || 'N/A'}</td>
                    <td style={tdStyle}>
                      <select
                        value={statusMap[msg.id] || 'new'}
                        onChange={e => handleStatusChange(msg.id, e.target.value)}
                        style={{
                          color:
                            statusMap[msg.id] === "new" ? "blue" :
                              statusMap[msg.id] === "in-progress" ? "orange" :
                                statusMap[msg.id] === "resolved" ? "green" :
                                  statusMap[msg.id] === "closed" ? "red" : "black"
                        }}
                      >
                        <option value="new" style={{ color: 'blue' }}>New</option>
                        <option value="in-progress" style={{ color: 'orange' }}>In Progress</option>
                        <option value="resolved" style={{ color: 'green' }}>Resolved</option>
                        {/* <option value="closed" style={{ color: 'red' }}>Closed</option> */}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

const thStyle = {
  border: '1px solid #ccc',
  padding: '10px',
  background: '#f4f4f4',
  color: indigo[500],
  textAlign: 'left'
};

const tdStyle = {
  border: '1px solid #ccc',
  padding: '10px',
  fontFamily: 'times new roman, serif',
  verticalAlign: 'top'
};

export default ContactMessages;
